@if (projectStatusData?.chartData?.length > 0) {
<div>
  <div class="chart-wrapper">
    <ngx-charts-pie-chart class="chart-body" [results]="projectStatusData?.chartData" [customColors]="colorTheme"></ngx-charts-pie-chart>
  </div>
  <div class="section-title">Project Status</div>
</div>
} @else {
<div class="no-data-message">No Projects To Display</div>
}
